import { render, staticRenderFns } from "./DotsLoader.vue?vue&type=template&id=19cfe1e8&scoped=true&"
import script from "./DotsLoader.vue?vue&type=script&lang=js&"
export * from "./DotsLoader.vue?vue&type=script&lang=js&"
import style0 from "./DotsLoader.vue?vue&type=style&index=0&id=19cfe1e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cfe1e8",
  null
  
)

export default component.exports